import { writable } from 'svelte/store';

const stop = () => {
  if(store.credentialsName){
    localStorage.setItem('credentialsName', store.credentialsName);
  }
};
const start = captureStore => {
  const credentialsName = localStorage.getItem('credentialsName');
  if(credentialsName) {
    store.credentialsName = credentialsName;
    captureStore(store);
  }
  return stop;
}
let credentialsName = '';
let store = {};
const CaptureStore = writable(store, start);
const setOverload = CaptureStore.set;
CaptureStore.set = value => {
  if(credentialsName !== value.credentialsName){
    if(value.credentialsName){
      localStorage.setItem('credentialsName', value.credentialsName);
    }
    credentialsName = value.credentialsName;
  }
  setOverload(value);
}

export default CaptureStore;
